import React from 'react';
import {
  DialogProps,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import ConfirmDialog from 'dialogs/ConfirmDialog';
import { IEquipment } from '../interfaces';

const useStyles = makeStyles({
  table: {
    '& tbody': {
      '& tr': {
        '& td': {
          backgroundColor: '#FAFAFA',
          transition: 'background-color 200ms',
        },
        '& td.MuiTableCell-head': {
          fontWeight: 600,
          backgroundColor: '#FDD7E7',
        },
        '&:hover': {
          '& td:not(.MuiTableCell-head)': {
            backgroundColor: '#f5f5f5',
          },
        },
      },
    },
  },
});

interface IProps {
  equipment: IEquipment | null;
  disabled?: boolean;
  onClose(): void;
  onConfirm(): void;
}

const DeleteEquipmentConfirmDialog: React.FC<IProps & DialogProps> = ({
  equipment,
  open,
  disabled,
  onClose,
  onConfirm,
}) => {
  // Styles
  const classes = useStyles();

  return (
    <ConfirmDialog
      open={open}
      title="Вы уверены, что хотите удалить тип оборудования?"
      disabled={disabled}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" className={classes.table}>
          <TableBody>
            <TableRow>
              <TableCell variant="head">Тип оборудования</TableCell>
              <TableCell>{equipment?.equipmentTypeName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell variant="head">Оборудование</TableCell>
              <TableCell>{equipment?.equipmentName}</TableCell>
            </TableRow>

            {equipment?.journalEquipmentItem && (
              <>
                <TableRow>
                  <TableCell variant="head">Количество</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.equipmentCount ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Производитель</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.equipmentCountry ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Модель</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.equipmentModel ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Серийный номер</TableCell>
                  <TableCell>
                    {equipment?.journalEquipmentItem?.equipmentSerialNumber.length
                      ? equipment?.journalEquipmentItem?.equipmentSerialNumber.join(', ')
                      : '—'}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Стоимость</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.equipmentCost ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Дата начала эксплуатации</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.dateStart ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Срок эксплуатации (месяцы)</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.monthCount ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Комментарий</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.comment ?? '—'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell variant="head">Гарантийный срок (месяцы)</TableCell>
                  <TableCell>{equipment?.journalEquipmentItem?.guaranteeMonth ?? '—'}</TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </ConfirmDialog>
  );
};
export default DeleteEquipmentConfirmDialog;
